import { components, paths } from "@api/api";
import useAxios from "@hooks/useFetch";

const RECENT_SEARCHES_ENDPOINT: keyof paths = '/api/RecentSearches/Get';

export type RecentSearchesResponseItem = components["schemas"]["FlavorTracker.Entities.Models.RecentSearch"];
export type RecentSearchesResponse = RecentSearchesResponseItem[];

export function useRecentSearches() {
    const response = useAxios<RecentSearchesResponse>({
        url: RECENT_SEARCHES_ENDPOINT,
        method: 'get',
    });

    return {
        ...response,
        data: response.data ?? [],
    };
}